export enum SeverityEnum {
  Error = 'error',
  Success = 'success',
  PartialyProcessed = 'partially_processed',
  StudentTypeDiscrepancy = 'student_type_discrepancy',
  Warning = 'warning',
  Danger = 'danger',
  Disabled = 'disabled',
  Default = 'default',
  DefaultBlue = 'default-blue',
  Info = 'info',
  Purple = 'purple',
  Processing = 'processing',
  Pending = 'pending'
}
